export default "__VITE_ASSET__fe3f9d69__"